import type { StateStorage } from 'zustand/middleware';

/**
 * `localStorage` that never throws.
 *
 * Storage can be full, disabled, or absent (a private window, a locked-down
 * browser), and each of those throws on write. A draft store must not turn
 * that into a crash in front of the person: what it loses in that case is
 * the reload guarantee, never the draft they are looking at. Shared by every
 * persisted draft store (tasks since spec 121, connections since spec 123).
 */
export const guardedLocalStorage: StateStorage = {
  getItem: (name) => {
    try {
      return window.localStorage.getItem(name);
    } catch {
      return null;
    }
  },
  setItem: (name, value) => {
    try {
      window.localStorage.setItem(name, value);
    } catch {
      // Kept in memory for the life of the tab.
    }
  },
  removeItem: (name) => {
    try {
      window.localStorage.removeItem(name);
    } catch {
      // Nothing to remove from storage that cannot be reached.
    }
  },
};
